module.exports = __webpack_public_path__ + "img/501.06bd0a16.png";